import { IPayment } from '@/modules/payment/types';

export const handleGetBundles = (
  list: IPayment.IBundleSchema[],
  bundleType: 'Enterprise' | 'Operations' | 'Business'
): IPayment.IBundleSchema | undefined => {
  return list.find((item) => item.bundleName.includes(bundleType));
};
export const handleSortingBundles = (
  list: IPayment.IBundleSchema[]
): IPayment.IBundleSchema[] => {
  const businessBundle = handleGetBundles(list, 'Business');
  const operationsBundle = handleGetBundles(list, 'Operations');
  const enterpriseBundle = handleGetBundles(list, 'Enterprise');

  const updatedList: IPayment.IBundleSchema[] = [];

  if (operationsBundle) {
    updatedList.push(operationsBundle);
  }
  if (businessBundle) {
    updatedList.push(businessBundle);
  }
  if (enterpriseBundle) {
    updatedList.push(enterpriseBundle);
  }
  return updatedList;
};

export const plansDetailsList: IPayment.IBundleDetailsSchema[] = [
  {
    title: 'bundle-details-title#1',
    description: 'bundle-details-description#1',
    bundles: [
      {
        available: true,
      },
      {
        available: true,
      },
      {
        available: true,
      },
    ],
  },
  {
    title: 'bundle-details-title#2',
    description: 'bundle-details-description#2',
    bundles: [
      {
        available: true,
      },
      {
        available: true,
      },
      {
        available: true,
      },
    ],
  },
  {
    title: 'bundle-details-title#3',
    description: 'bundle-details-description#3',
    bundles: [
      {
        available: false,
      },
      {
        available: true,
      },
      {
        available: true,
      },
    ],
  },
  {
    title: 'bundle-details-title#4',
    description: 'bundle-details-description#4',
    bundles: [
      {
        available: false,
      },
      {
        available: true,
      },
      {
        available: true,
      },
    ],
  },
  {
    title: 'bundle-details-title#5',
    description: 'bundle-details-description#5',
    bundles: [
      {
        available: false,
      },
      {
        available: true,
      },
      {
        available: true,
        description: 'including-custom-reporting',
      },
    ],
  },
  {
    title: 'bundle-details-title#6',
    description: 'bundle-details-description#6',
    bundles: [
      {
        available: false,
      },
      {
        available: true,
      },
      {
        available: true,
      },
    ],
  },
  {
    title: 'bundle-details-title#7',
    description: 'bundle-details-description#7',
    bundles: [
      {
        available: false,
      },
      {
        available: false,
      },
      {
        available: true,
      },
    ],
  },
];

export const plansDetailsCollapseList: IPayment.IBundleDetailsCollapseSchema[] =
  [
    {
      collapseTitle: 'collapse-title#1',
      collapseList: [
        {
          title: 'collapse#1-details-title#1',
          description: 'collapse#1-details-description#1',
          bundles: [
            {
              description: 'unlimited',
            },
            {
              description: 'unlimited',
            },
            {
              description: 'unlimited',
            },
          ],
        },
        {
          title: 'collapse#1-details-title#2',
          description: 'collapse#1-details-description#2',
          bundles: [
            {
              description: 'can-be-one',
            },
            {
              description: 'can-be-one',
            },
            {
              description: 'can-be-one',
            },
          ],
        },
        {
          title: 'collapse#1-details-title#3',
          description: 'collapse#1-details-description#3',
          bundles: [
            {
              description: 'unlimited',
            },
            {
              description: 'unlimited',
            },
            {
              description: 'unlimited',
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#2',
      collapseList: [
        {
          title: 'collapse#2-details-title#1',
          description: 'collapse#2-details-description#1',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#2-details-title#2',
          description: 'collapse#2-details-description#2',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#2-details-title#3',
          description: 'collapse#2-details-description#3',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#3',
      collapseList: [
        {
          title: 'collapse#3-details-title#1',
          description: 'collapse#3-details-description#1',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#3-details-title#2',
          description: 'collapse#3-details-description#2',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#3-details-title#3',
          description: 'collapse#3-details-description#3',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#3-details-title#4',
          description: 'collapse#3-details-description#4',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#4',
      collapseList: [
        {
          title: 'collapse#4-details-title#1',
          description: 'collapse#4-details-description#1',
          bundles: [
            {
              available: false,
            },
            {
              description: 'unlimited',
            },
            {
              description: 'unlimited',
            },
          ],
        },
        {
          title: 'collapse#4-details-title#2',
          description: 'collapse#4-details-description#2',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#3',
          description: 'collapse#4-details-description#3',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#4',
          description: 'collapse#4-details-description#4',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#5',
          description: 'collapse#4-details-description#5',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#6',
          description: 'collapse#4-details-description#6',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#7',
          description: 'collapse#4-details-description#7',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#4-details-title#8',
          description: 'collapse#4-details-description#8',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#5',
      collapseList: [
        {
          title: 'collapse#5-details-title#1',
          description: 'collapse#5-details-description#1',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#5-details-title#2',
          description: 'collapse#5-details-description#2',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#5-details-title#3',
          description: 'collapse#5-details-description#3',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#5-details-title#4',
          description: 'collapse#5-details-description#4',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#6',
      collapseList: [
        {
          title: 'collapse#6-details-title#1',
          description: 'collapse#6-details-description#1',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#6-details-title#2',
          description: 'collapse#6-details-description#2',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#6-details-title#3',
          description: 'collapse#6-details-description#3',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#6-details-title#4',
          description: 'collapse#6-details-description#4',
          bundles: [
            {
              available: false,
            },
            {
              available: false,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#7',
      collapseList: [
        {
          title: 'collapse#7-details-title#1',
          description: 'collapse#7-details-description#1',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#7-details-title#2',
          description: 'collapse#7-details-description#2',
          bundles: [
            {
              available: false,
            },
            {
              available: false,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
    {
      collapseTitle: 'collapse-title#8',
      collapseList: [
        {
          title: 'collapse#8-details-title#1',
          description: 'collapse#8-details-description#1',
          bundles: [
            {
              available: false,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
        {
          title: 'collapse#8-details-title#2',
          description: 'collapse#8-details-description#2',
          bundles: [
            {
              available: true,
            },
            {
              available: true,
            },
            {
              available: true,
            },
          ],
        },
      ],
    },
  ];

export const handleEnterpriseSubscription = () => {
  window.open('https://www.aydi.com/book-a-demo', '_blank');
};
